module.exports = __webpack_public_path__ + "static/img/guanwang2.cd32a573.png";